import * as React from "react";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { values } from "lodash";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceAudiometrySectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    const enableHealthSurveillanceCrBugs = getFeatureToggles()[FeatureToggleNames.HealthSurveillanceCrBugs];
    const questions = values(props.questions || {});

    return (
        <ContextAwareProgressBarQuestionnaireSection
            {...props}
            {...sections.Audiometry}
        >
            <h4>Current Noise Exposure History</h4>
            <TextQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.OccupationalNoiseExposedTo)} readonly={props.readonly} />
            <TextQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HowLongExposedToNoise)} readonly={props.readonly} />
            {(!enableHealthSurveillanceCrBugs || (props.readonly && getAnswerToQuestionWithId(questions, questionIds.HobbiesExposedToNoise))) &&
                <TextQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HobbiesExposedToNoise)} readonly={props.readonly} />}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EarInjuriesInfectionsDiseases),
                    getQuestionConfig(props.questionConfigs, questionIds.EarInjuriesInfectionsDiseasesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.NoisesInEars),
                    getQuestionConfig(props.questionConfigs, questionIds.NoisesInEarsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EarDischargeOrWaxBuildUp),
                    getQuestionConfig(props.questionConfigs, questionIds.EarDischargeOrWaxBuildUpFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DifficultWithHearing),
                    getQuestionConfig(props.questionConfigs, questionIds.DifficultWithHearingFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverKnockedUnconscious),
                    getQuestionConfig(props.questionConfigs, questionIds.EverKnockedUnconsciousFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DizzinessOrVertigo),
                    getQuestionConfig(props.questionConfigs, questionIds.DizzinessOrVertigoFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverHearingLostDueToIllness),
                    getQuestionConfig(props.questionConfigs, questionIds.EverHearingLostDueToIllnessFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EarDiseaseOrDeafnessInFamily),
                    getQuestionConfig(props.questionConfigs, questionIds.EarDiseaseOrDeafnessInFamilyFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ExposureGunfireExplosions),
                    getQuestionConfig(props.questionConfigs, questionIds.ExposureGunfireExplosionsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ExposureNoisePreviousOccupation),
                    getQuestionConfig(props.questionConfigs, questionIds.ExposureNoisePreviousOccupationFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ExposureNoiseLeisureActivities),
                    getQuestionConfig(props.questionConfigs, questionIds.ExposureNoiseLeisureActivitiesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.TakingMedicationAffectingHearing),
                    getQuestionConfig(props.questionConfigs, questionIds.TakingMedicationAffectingHearingFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ExposedNoisyEnvironmentLast48Hours),
                    getQuestionConfig(props.questionConfigs, questionIds.ExposedNoisyEnvironmentLast48HoursFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.WornEarProtectionLast48Hours),
                    getQuestionConfig(props.questionConfigs, questionIds.WornEarProtectionLast48HoursFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Ear Protection</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.WearEarProtectionWhenAdvised),
                    getQuestionConfig(props.questionConfigs, questionIds.WearEarProtectionWhenAdvisedFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {getAnswerToQuestionWithId(questions, questionIds.WearEarProtectionWhenAdvised) === MultiButtonQuestion.YesOption &&
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.WearEarProtectionWhenAdvisedType)}
                readonly={props.readonly}
                options={[
                    { text: "Earplugs", value: "Earplugs" },
                    { text: "Eardefenders", value: "Eardefenders" },
                ]}
            />}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.WearEarProtectionPreviousEmployment),
                    getQuestionConfig(props.questionConfigs, questionIds.WearEarProtectionPreviousEmploymentFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {getAnswerToQuestionWithId(questions, questionIds.WearEarProtectionPreviousEmployment) === MultiButtonQuestion.YesOption &&
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.WearEarProtectionPreviousEmploymentType)}
                readonly={props.readonly}
                options={[
                    { text: "Earplugs", value: "Earplugs" },
                    { text: "Eardefenders", value: "Eardefenders" },
                ]}
            />}
        </ContextAwareProgressBarQuestionnaireSection>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceAudiometrySection = connect(makeMapStateToQuestionnaireSectionProps(sections.Audiometry.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceAudiometrySectionUnconnected);
